module.exports = __webpack_public_path__ + "static/media/12UNCTAD14.6ce12b2f.jpg";